var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bigBg",
      staticStyle: { display: "flex", "flex-wrap": "wrap" },
      attrs: { id: "bigPage" },
    },
    [
      _c("div", { staticClass: "pageTop1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              color: "#2bc7ff",
              "font-size": "24px",
              width: "33.33%",
              "text-align": "center",
              "font-weight": "bold",
            },
          },
          [_vm._v("\n      咖德保安大数据运行专题\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              width: "33.33%",
              "justify-content": "center",
              color: "#fff",
            },
          },
          [
            _c("div", [_vm._v("按地区")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "custom-select",
                staticStyle: {
                  "margin-left": "8px",
                  width: "100px",
                  "min-height": "20 !important",
                  height: "20px !important",
                },
                attrs: { placeholder: "请选择" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.value1,
                  callback: function ($$v) {
                    _vm.value1 = $$v
                  },
                  expression: "value1",
                },
              },
              [
                _c("el-option", { attrs: { label: "全国", value: "全国" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "广东", value: "广东" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "北京", value: "北京" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "上海", value: "上海" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "smallIcon",
              attrs: { src: require("../../assets/imgs/refresh.png"), alt: "" },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "smallIcon",
              attrs: { src: require("../../assets/imgs/clear.png"), alt: "" },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "smallIcon",
              attrs: { src: require("../../assets/imgs/big.png"), alt: "" },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-left": "20px", "margin-top": "-6px" } },
              [_vm._v("\n        2025年10月14日    12:12\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        ref: "echartsRef",
        staticStyle: { width: "600px", height: "400px" },
      }),
      _vm._v(" "),
      _c("div", {
        ref: "chartContainer",
        staticStyle: { width: "600px", height: "400px" },
      }),
      _vm._v(" "),
      _c("div", {
        ref: "echartsRef1",
        staticStyle: { width: "600px", height: "400px" },
        on: { mouseenter: _vm.kk, mouseleave: _vm.startInterval },
      }),
      _vm._v(" "),
      _c("div", {
        ref: "chartContainer1",
        staticStyle: { width: "600px", height: "400px" },
      }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "33.33%" } }, [
      _c("img", {
        staticStyle: {
          width: "80px",
          height: "20px",
          "margin-left": "16px",
          "margin-top": "-30px",
        },
        attrs: { src: require("../../assets/imgs/logo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }